"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueLabel = exports.InputRangeWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
// import 'react-input-range/lib/css/index.css';

var InputRangeWrapper = exports.InputRangeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBSliderstyles__InputRangeWrapper",
  componentId: "sc-age59b-0"
})([".input-range{&__track{&--background{background-color:", ";width:100%;height:4px;border-radius:2px;.input-range__track{&--active{background:", ";height:100%;border-radius:2px;}}}}&__slider{width:20px;height:20px;box-shadow:0 3px 8px 0 rgba(36,39,43,0.3),0 1px 3px 0 rgba(0,0,0,0.2);background-color:", ";border-radius:50%;margin-top:-12px;margin-left:-10px;cursor:pointer;transition:transform 0.3s ease-out,box-shadow 0.3s ease-out;}&__label--max,&__label--min,&__label--value{display:none;}}"], _colors["default"].neutral200, _colors["default"].blue20, _colors["default"].white);
var ValueLabel = exports.ValueLabel = _styledComponents["default"].label.withConfig({
  displayName: "HBSliderstyles__ValueLabel",
  componentId: "sc-age59b-1"
})(["position:absolute;right:0;top:-24px;", ";font-size:14px;line-height:1.29;color:", ";"], _mixins.proximaNova, _colors["default"].neutral600);
//# sourceMappingURL=HBSlider.styles.js.map